module.exports = __webpack_public_path__ + "img/pet_story.1deda936.svg";